<template>
  <div :class="$style.wrap">
    <div :class="$style.title">
      <p>您所填手机号未注册</p>
      <p>
        请设置密码创建手机账号：
        <span>{{ iconPhone }}</span>
      </p>
    </div>
    <base-form
      ref="form"
      label-width="2em"
      :items="data"
      @submit="onSubmit"
      submit-text="立即注册"
    />
    <div :class="$style.giveUp">
      <van-button
        round
        size="large"
        tag="input"
        value="放弃注册"
        native-type="submit"
        @click.stop.prevent="giveUpRegister"
      />
    </div>
    <Agreement ref="agreement" />
  </div>
</template>
<script>
import { mixinRegistered } from "@/mixins/mixinRegistered";
import { mixinForward } from "@/mixins/mixinForward";
import fallback from "@/utils/fallback";
export default {
  name: "registered",
  mixins: [mixinRegistered, mixinForward],
  data() {
    return {
      data: [{ name: "password" }],
      iconPhone: this.$route.query.iconPhone,
      iconPhoneCode: this.$route.query.iconPhoneCode
    };
  },
  mounted() {
    // 初使化 md5
    if (!window.hex_md5) fallback("md5");
  },
  // 路由前置处理
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.iconPhone) {
        vm.$router.replace({ path: vm._anchor.login.path });
      }
    });
  },
  methods: {
    /**
     * @description 步骤提交
     * @param {object} formdata  - 表单对象值
     * @param {object} validate  - 极致验证
     */
    onSubmit(formdata, validate) {
      // 验证密码是否与输入的手机号码相同
      let { password } = formdata;
      if (this.iconPhone == password) {
        this.showToast();
        return false;
      }

      // 验证协议是否勾选
      if (!this.$refs.agreement || !this.$refs.agreement.checked) {
        this.showToast("请先勾选用户协议及隐私政策");
        return false;
      }

      const parmas = Object.assign(
        {},
        {
          phone: this.iconPhone,
          password: window.hex_md5(password),
          code: this.iconPhoneCode,
          type: null //手机正常注册 接口默认为无
        },
        validate || {}
      );
      this.doPhone(parmas, "registered");
    },
    giveUpRegister() {
      this.$router.replace({ path: this._anchor.login.path });
    }
  }
};
</script>
<style lang="less" module>
.wrap {
  :global {
    .van-field__control {
      padding: 0.16rem 0 0.16rem 0.7rem;
    }
  }
  .title {
    margin: 0.6rem 0 0.86rem 0;
    padding-left: 0.45rem;
    p,
    span {
      font-size: 0.3rem;
      font-weight: normal;
      font-stretch: normal;
      line-height: 0.48rem;
      letter-spacing: 0rem;
    }
    p {
      color: #222222;
    }
    span {
      color: #48d5af;
    }
  }
  .giveUp {
    .flex-center;
    .flex-col;
    .size(100%, auto);
    margin-top: 0.22rem;
    :global {
      input {
        width: 3.88rem;
        border-radius: 0.39rem;
        border: solid 0.02rem #48d5af;
        color: #48d5af;
      }
    }
  }
}
</style>
